import { render, staticRenderFns } from "./tabar.vue?vue&type=template&id=228158b4&scoped=true"
import script from "./tabar.vue?vue&type=script&lang=js"
export * from "./tabar.vue?vue&type=script&lang=js"
import style0 from "./tabar.vue?vue&type=style&index=0&id=228158b4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228158b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('228158b4')) {
      api.createRecord('228158b4', component.options)
    } else {
      api.reload('228158b4', component.options)
    }
    module.hot.accept("./tabar.vue?vue&type=template&id=228158b4&scoped=true", function () {
      api.rerender('228158b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tabar.vue"
export default component.exports